import React from 'react';
import { Field, Section } from './shared';

const MODES = [
  { value: 'round_robin', label: 'Rodízio' },
  { value: 'fixed', label: 'Responsável fixo' },
];

const toIntOrUndef = (v) => (v === '' || v == null ? undefined : Number(v));

function OutcomeFields({ outcome = {}, onChange }) {
  const set = (patch) => {
    const next = { ...outcome, ...patch };
    Object.keys(next).forEach((k) => next[k] === undefined && delete next[k]);
    onChange(next);
  };
  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
      <Field label="Funil (ID)">
        <input className="input" type="number" min={1} value={outcome.pipelineId ?? ''} onChange={(e) => set({ pipelineId: toIntOrUndef(e.target.value) })} />
      </Field>
      <Field label="Etapa (ID)">
        <input className="input" type="number" min={1} value={outcome.stageId ?? ''} onChange={(e) => set({ stageId: toIntOrUndef(e.target.value) })} />
      </Field>
      <Field label="Atribuição">
        <select className="input" value={outcome.assigneeMode || 'round_robin'}
          onChange={(e) => set({ assigneeMode: e.target.value, ...(e.target.value !== 'fixed' ? { assigneeId: undefined } : {}) })}>
          {MODES.map((m) => <option key={m.value} value={m.value}>{m.label}</option>)}
        </select>
      </Field>
      {outcome.assigneeMode === 'fixed' && (
        <Field label="Responsável (ID)">
          <input className="input" type="number" min={1} value={outcome.assigneeId ?? ''} onChange={(e) => set({ assigneeId: toIntOrUndef(e.target.value) })} />
        </Field>
      )}
    </div>
  );
}

export default function RoutingTab({ schema, onChange }) {
  const questions = (schema.questions || []).filter((q) => q.type !== 'notice');
  const rules = schema.routing || [];
  const setRules = (next) => onChange({ ...schema, routing: next });

  const addRule = () => setRules([
    ...rules,
    { when: { questionId: questions[0]?.id || '', equals: '' }, outcome: { assigneeMode: 'round_robin' } },
  ]);
  const updateRule = (i, patch) => setRules(rules.map((r, j) => (j === i ? { ...r, ...patch } : r)));

  return (
    <div className="space-y-4">
      <p className="text-sm text-slate-500">
        As regras são avaliadas em ordem; a primeira que combina define o destino do lead no CRM. Sem combinação, vale o destino padrão.
      </p>

      {rules.map((rule, i) => {
        const q = (schema.questions || []).find((x) => x.id === rule.when?.questionId);
        const listId = `routing-opts-${i}`;
        return (
          <Section key={i}>
            <div className="flex items-center justify-between">
              <span className="text-xs font-bold text-slate-400">REGRA {i + 1}</span>
              <button type="button" className="p-1.5 rounded text-red-500 hover:bg-red-50" title="Remover regra" aria-label="Remover regra"
                onClick={() => setRules(rules.filter((_, j) => j !== i))}>
                <span className="material-symbols-outlined text-[18px]">delete</span>
              </button>
            </div>
            <div className="grid sm:grid-cols-2 gap-3">
              <Field label="Quando a pergunta">
                <select className="input" value={rule.when?.questionId || ''}
                  onChange={(e) => updateRule(i, { when: { ...rule.when, questionId: e.target.value } })}>
                  {questions.map((x) => <option key={x.id} value={x.id}>{x.label || x.id}</option>)}
                </select>
              </Field>
              <Field label="For igual a">
                <input className="input" list={listId} value={rule.when?.equals ?? ''} maxLength={200}
                  onChange={(e) => updateRule(i, { when: { ...rule.when, equals: e.target.value } })} />
                <datalist id={listId}>
                  {(q?.options || []).map((o) => <option key={o} value={o} />)}
                </datalist>
              </Field>
            </div>
            <OutcomeFields outcome={rule.outcome} onChange={(outcome) => updateRule(i, { outcome })} />
          </Section>
        );
      })}

      <button type="button" className="btn btn-secondary flex items-center gap-2" onClick={addRule} disabled={questions.length === 0}>
        <span className="material-symbols-outlined text-[18px]">add</span>
        Adicionar regra
      </button>

      <Section title="Destino padrão">
        {schema.defaultOutcome ? (
          <>
            <OutcomeFields outcome={schema.defaultOutcome} onChange={(o) => onChange({ ...schema, defaultOutcome: o })} />
            <button type="button" className="text-sm text-red-600 font-bold"
              onClick={() => { const { defaultOutcome, ...rest } = schema; onChange(rest); }}>
              Remover destino padrão
            </button>
          </>
        ) : (
          <button type="button" className="text-sm text-primary font-bold"
            onClick={() => onChange({ ...schema, defaultOutcome: { assigneeMode: 'round_robin' } })}>
            + Definir destino padrão
          </button>
        )}
      </Section>
    </div>
  );
}
